/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from '@/plugins';
import './styles/main.scss';
// Components
import App from './App.vue';

// Composables
import { createApp } from 'vue';

// FIREBASE
import { initializeApp } from 'firebase/app';
import { getEnvVars, isFirebaseConfigured } from '@/configs/env';

// Validate environment variables
try {
    getEnvVars();
} catch (error) {
    console.error('Environment validation failed:', error);
    // In production, you might want to show an error page instead
    throw error;
}

// Initialize Firebase if configured
if (isFirebaseConfigured()) {
    const env = import.meta.env;
    initializeApp({
        apiKey: env.VITE_APP_FIREBASE_API_KEY,
        authDomain: env.VITE_APP_FIREBASE_AUTH_DOMAIN,
        projectId: env.VITE_APP_FIREBASE_PROJECT_ID,
        storageBucket: env.VITE_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: env.VITE_APP_FIREBASE_MESSAGE_SENDER_ID,
        appId: env.VITE_APP_FIREBASE_APP_ID,
    });
}

const app = createApp(App);

registerPlugins(app);

app.mount('#app');
